import { Profile, mapStateToProps } from './Profile';
import React from 'react';
import { Link } from 'react-router-dom';
import agent from '../agent';
import { connect } from 'react-redux';
import {
  PROFILE_PAGE_LOADED,
  PROFILE_PAGE_UNLOADED
} from '../constants/actionTypes';
import './profile.css';

const mapDispatchToProps = dispatch => ({
  onLoad: payload => dispatch({ type: PROFILE_PAGE_LOADED, payload }),
  onUnload: () => dispatch({ type: PROFILE_PAGE_UNLOADED })
});

class ProfileFavorites extends Profile {

  componentWillMount() {
    this.props.onLoad(Promise.all([
      agent.Profile.get(this.props.match.params.username),
      agent.Articles.byAuthorByTime(this.props.match.params.username)
    ]));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  renderTabs() {
    return (
      <div className="nav-bar">
        <div className="nav-btn-inactive">
          <Link className="nav-text-inactive"
            to={`/${this.props.profile.handle}`}>
            Top Voted
          </Link>
        </div>

        <div className="nav-btn-active">
          <Link className="nav-text-active"
            to={`/${this.props.profile.handle}/recent`}>
            Most Recent
          </Link>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileFavorites);




// WEBPACK FOOTER //
// ./src/components/ProfileFavorites.js